/** Short notices from the app: a connection made, stale balances (`finance_alert`). */
import { create } from "zustand";

export interface Notice {
  id: number;
  text: string;
}

let next = 1;

export const useNotices = create<{
  notices: Notice[];
  push(text: string): void;
  dismiss(id: number): void;
}>()((set) => ({
  notices: [],
  push: (text) => set((s) => ({ notices: [...s.notices, { id: next++, text }] })),
  dismiss: (id) => set((s) => ({ notices: s.notices.filter((n) => n.id !== id) })),
}));
